export default __webpack_public_path__ + "static/media/upload.9290c3b6.svg";